import { render } from "./SlideOverAttachProject.vue?vue&type=template&id=229ca214"
import script from "./SlideOverAttachProject.vue?vue&type=script&lang=js"
export * from "./SlideOverAttachProject.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__